import {
    EMPLOYEE_BENEFICIARYS_FETCHING,
    EMPLOYEE_BENEFICIARYS_SUCCESS,
    EMPLOYEE_BENEFICIARYS_FAILED,
  } from "../actions/types";
  
  const initialState = {
    result: null,
    isFetching: false,
    isError: false,
  };
  
  export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
      case EMPLOYEE_BENEFICIARYS_FETCHING:
        return { ...state, result: null, isFetching: true, isError: false };
      case EMPLOYEE_BENEFICIARYS_FAILED:
        return { ...state, result: null, isFetching: false, isError: false };
      case EMPLOYEE_BENEFICIARYS_SUCCESS:
        return { ...state, result: payload, isFetching: false, isError: false };
      default:
        return state;
    }
  }
  